let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1BUH2")).then(() => parcelRequire('l3SRu'));